module.exports = __webpack_public_path__ + "static/img/feedback.6c9e286.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/feedback.png
// module id = 5v/v
// module chunks = 1